import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import './Toldos.css';

// Imágenes
import retractilImage from './images/imagen4.png';
import verticalImage from './images/ToldoVertical.png';
import headerToldos from './images/ToldosHe.png';
import toldoima from './images/ToldoInstalado.png';
import retractilImaged from './images/RetractilInstalado.png';

const ToldosPremium = () => {
  const { t } = useTranslation();

  const [activeTab, setActiveTab] = useState('verticales');
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);

  // ===== Texto i18n (objetos anidados) =====
  const awningsText = t('awningsPage', { returnObjects: true });

  // ===== Tabs UI (labels desde i18n) =====
  const tabs = [
    {
      id: 'verticales',
      label: awningsText.tabs.verticales,
      icon: (
        <img
          src={verticalImage}
          alt={t('awningsPage.aria.iconAltVertical', 'Icono de toldos verticales')}
          className="tab-icon-image"
        />
      ),
    },
    {
      id: 'retractiles',
      label: awningsText.tabs.retractiles,
      icon: (
        <img
          src={retractilImage}
          alt={t('awningsPage.aria.iconAltRetractil', 'Icono de toldos retráctiles')}
          className="tab-icon-image"
        />
      ),
    },
  ];

  // ===== Contenido (texto desde i18n + imágenes locales) =====
  const contentData = {
    verticales: {
      title: awningsText.content.verticales.title,
      fullDescription: awningsText.content.verticales.fullDescription,
      features: awningsText.content.verticales.features,
      images: [toldoima],
      altBase: awningsText.content.verticales.altBase,
      ctaPrimaryText: awningsText.content.verticales.ctaPrimaryText,
      ctaPrimaryHref: 'https://wa.me/50660458068',
    },
    retractiles: {
      title: awningsText.content.retractiles.title,
      fullDescription: awningsText.content.retractiles.fullDescription,
      features: awningsText.content.retractiles.features,
      images: [retractilImaged],
      altBase: awningsText.content.retractiles.altBase,
      ctaPrimaryText: awningsText.content.retractiles.ctaPrimaryText,
      ctaPrimaryHref: 'https://wa.me/50660458068',
    },
  };

  const {
    title,
    fullDescription,
    features,
    images,
    altBase,
    ctaPrimaryText,
    ctaPrimaryHref,
  } = contentData[activeTab];

  // ===== Gallery handlers =====
  const nextImage = () => setCurrentImageIndex((prev) => (prev + 1) % images.length);
  const prevImage = () => setCurrentImageIndex((prev) => (prev - 1 + images.length) % images.length);

  // ===== Animations =====
  const imageVariants = {
    hidden: { opacity: 0, x: 50 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.8 } },
    exit: { opacity: 0, x: -50 },
  };
  const textVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, delay: 0.2 } },
  };

  // ===== JSON-LD (opcionalmente podrías traducir con i18n también) =====
  const itemListJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: t('awningsPage.seo.itemListName', 'Tipos de toldos a medida'),
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: t('awningsPage.tabs.verticales') },
      { '@type': 'ListItem', position: 2, name: t('awningsPage.tabs.retractiles') },
    ],
  };

  const serviceJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: t('awningsPage.seo.serviceName', 'Diseño, fabricación e instalación de toldos a medida'),
    provider: { '@type': 'LocalBusiness', name: 'RollerUp' },
    areaServed: 'Costa Rica',
    serviceType: t('awningsPage.seo.serviceType', 'Toldos verticales y retráctiles'),
    brand: 'RollerUp',
    description: t(
      'awningsPage.seo.serviceDescription',
      'Servicio integral de toldos verticales y retráctiles a medida en Costa Rica. Asesoría técnica, materiales para intemperie, motorización y garantía.'
    ),
  };

  return (
    
    <motion.div
      className="toldos-premium-container"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
 {/* Header con imagen */}
      <div className="toldos-header-container">
        <img
          src={headerToldos}
          alt={t('awningsPage.aria.headerAlt', 'Toldos a medida en Costa Rica')}
          className="toldos-header-image"
          loading="eager"
        />
        <div className="toldos-header-overlay">
          {/* Único H1 para SEO */}
          <h1 className="toldos-header-title">{awningsText.ui.titleMain}</h1>
        </div>
      </div>
      <br/>
      <br/>
      <br/>
      {/* Tabs */}
      <div
        className="premium-tabs-container"
        role="tablist"
        aria-label={awningsText.aria.tablist}
      >
      <br/>
      <br/>
      <br/>
        {tabs.map((tab) => (
          <motion.button
            key={tab.id}
            className={`premium-tab ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => {
              setActiveTab(tab.id);
              setCurrentImageIndex(0);
            }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            role="tab"
            aria-selected={activeTab === tab.id}
            aria-controls={`panel-${tab.id}`}
            id={`tab-${tab.id}`}
          >
            <span className="tab-icon">{tab.icon}</span>
            <span>{tab.label}</span>
            {activeTab === tab.id && (
              <span className="sr-only">{awningsText.aria.selectedSuffix}</span>
            )}
          </motion.button>
        ))}
      </div>

      {/* Contenido */}
      <div className="premium-content-container">

          {/* Fondo decorativo */}
        <div className="premium-background" aria-hidden="true"></div>

        <motion.div
          className="premium-text-content"
          variants={textVariants}
          initial="hidden"
          animate="visible"
          key={activeTab}
          id={`panel-${activeTab}`}
          role="tabpanel"
          aria-labelledby={`tab-${activeTab}`}
        >
          <motion.h2 className="premium-product-title">{title}</motion.h2>

          <motion.p className="premium-product-description">{fullDescription}</motion.p>

          <div className="premium-features-section">
            <h3>{t('awningsPage.ui.featuresTitle', 'CARACTERÍSTICAS DESTACADAS')}</h3>
            <ul className="premium-features-list">
              {features.map((feature, index) => (
                <motion.li
                  key={index}
                  initial={{ x: -20, opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                  transition={{ delay: index * 0.08 }}
                >
                  <span className="premium-check-icon" aria-hidden="true">
                    ✓
                  </span>
                  {feature}
                </motion.li>
              ))}
            </ul>
          </div>

          <div className="premium-ctas">
            <motion.a
              href={ctaPrimaryHref}
              className="premium-cta-button primary"
              whileHover={{ scale: 1.05, boxShadow: '0 6px 18px rgba(234, 98, 38, 0.35)' }}
              whileTap={{ scale: 0.98 }}
              aria-label={`${ctaPrimaryText} — ${title}`}
            >
              {ctaPrimaryText} <span className="cta-arrow">➔</span>
            </motion.a>
          </div>
        </motion.div>

        {/* Galería */}
        <div
          className="premium-image-content"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <AnimatePresence mode="wait">
            <motion.div
              key={`${activeTab}-${currentImageIndex}`}
              variants={imageVariants}
              initial="hidden"
              animate="visible"
              exit="exit"
              className="premium-image-wrapper"
            >
              <img
                src={images[currentImageIndex]}
                alt={`${altBase} (${t('blindsPage.aria.image', { index: currentImageIndex + 1 })})`}
                className="premium-product-image"
                loading="lazy"
              />

              {images.length > 1 && (
                <div className={`premium-image-controls ${isHovered ? 'visible' : ''}`}>
                  <motion.button
                    className="premium-control-button"
                    onClick={prevImage}
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.9 }}
                    aria-label={awningsText.aria.prevImage}
                  >
                    ‹
                  </motion.button>
                  <motion.button
                    className="premium-control-button"
                    onClick={nextImage}
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.9 }}
                    aria-label={awningsText.aria.nextImage}
                  >
                    ›
                  </motion.button>
                </div>
              )}

              {images.length > 1 && (
                <div className="premium-image-counter" aria-live="polite">
                  {currentImageIndex + 1}/{images.length}
                </div>
              )}
            </motion.div>
          </AnimatePresence>
        </div>
      </div>

      <div className="premium-badge" aria-label={t('awningsPage.ui.qualityBadgeAria', 'Garantía de calidad')}>
        <span>{t('awningsPage.ui.qualityBadge', 'GARANTÍA DE CALIDAD')}</span>
      </div>

      {/* JSON-LD */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(itemListJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(serviceJsonLd) }}
      />
    </motion.div>
  );
};

export default ToldosPremium;
